/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Page_Online_LedeInputs */

const en_vc_page_online_lede = /** @type {(inputs: Vc_Page_Online_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the full VectorCraft app compiled to WebAssembly, the same version as the desktop download. Click Launch to start it. There is no account or install, and drawing happens entirely on your own computer.`)
};

const zh_vc_page_online_lede = /** @type {(inputs: Vc_Page_Online_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是编译成 WebAssembly 的完整版 VectorCraft，与桌面下载版是同一个版本。点击「启动」即可使用，无需账号和安装，所有绘图都在你自己的电脑上完成。`)
};

/**
* | output |
* | --- |
* | "This is the full VectorCraft app compiled to WebAssembly, the same version as the desktop download. Click Launch to start it. There is no account or install,..." |
*
* @param {Vc_Page_Online_LedeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_page_online_lede = /** @type {((inputs?: Vc_Page_Online_LedeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Page_Online_LedeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_page_online_lede(inputs)
	return zh_vc_page_online_lede(inputs)
});
export { vc_page_online_lede as "vc.page.online.lede" }